import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import Pluraliser from '../ui/Pluraliser';
import PropTypes from 'prop-types';
import SearchQuery from '../search2/SearchQuery';
//import SearchResult from './SearchResult';
import SearchResultList from './SearchResultList';
import VerseVersions from './VerseVersions';
import './SearchView.css';

export default class SearchView extends Component {
    static propTypes = {
        //queryText: PropTypes.string,
        //language: PropTypes.string,
        query: PropTypes.instanceOf(SearchQuery),
        onVerseClick: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            results: null,
            searching: false
        }
        this.doUpdateResults = false;
        this.updateResults = this.updateResults.bind(this);
        this.onResultClick = this.onResultClick.bind(this);
    }

    componentDidMount() {
        this.updateResults();
    }

    componentWillReceiveProps(nextProps) {
        //if (this.props.queryText !== nextProps.queryText ||
        //        this.props.language !== nextProps.language) {
        if (this.props.query !== nextProps.query) {
            this.doUpdateResults = true;
        }
    }

    componentDidUpdate() {
        if (this.doUpdateResults) {
            this.doUpdateResults = false;
            this.updateResults();
        }
    }

    updateResults() {
        if (this.props.query) {
            this.setState({ searching: true });
            VerseVersions.search(this.props.query.getText(), this.props.query.getLanguage(), false)
                    .then(results => this.setState({ results, searching: false }))
                    .catch(error => console.log(error));
        } else {
            this.setState({
                results: null,
                searching: false
            });
        }
    }

    onResultClick(result) {
        this.props.onVerseClick(result.index);
        //this.props.onVerseClick(this.state.results.results[index].index);
    }

    getQueryTextClasses() {
        const classes = ['SearchView_QueryText'];
        switch (this.props.query.getLanguage()) {
            case 'hebrew':
                classes.push('_Hebrew');
                break;
            case 'greek':
                classes.push('_Greek');
                break;
            default:
                break;
        }
        return classes.join(' ');
    }

    render() {
        const results = this.state.results;
        const haveResults = results && results.results.length > 0;
        var content;
        if (this.state.searching) {
            content = <CircularProgress className="SearchView_Loading" color="secondary" />;
        } else if (!haveResults) {
            content = <div className="SearchView_Empty">No results</div>;
        } else {
            /*content = (
                <div>
                    {results.results.map((result, index) =>
                        <SearchResult key={index} result={result}
                            queryText={this.props.queryText}
                            onClick={() => this.onResultClick(index)} />)}
                </div>
            );*/
            content = <SearchResultList
                results={results.results}
                query={this.props.query}
                onResultClick={this.onResultClick} />;
        }
        return (
            <div className="SearchView">
                {haveResults && <div className="SearchView_Info">
                    <div className={this.getQueryTextClasses()}>{this.props.query.getText()}</div>
                    <Pluraliser value={results.count} text="result" className="SearchView_ResultCount" />
                </div>}
                <div className="SearchView_Content">{content}</div>
            </div>
        );
    }
}
